import { render, staticRenderFns } from "./globalsearch.vue?vue&type=template&id=969d3ffa"
import script from "./globalsearch.vue?vue&type=script&lang=js"
export * from "./globalsearch.vue?vue&type=script&lang=js"
import style0 from "./globalsearch.vue?vue&type=style&index=0&id=969d3ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports